import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';

/**
 * Composant de garde qui bloque le rendu desktop sur mobile
 * Redirige immédiatement vers l'application mobile
 * 
 * IMPORTANT: Ce composant doit être utilisé comme `element` dans une Route,
 * donc il utilise `Outlet` pour rendre les routes enfants, pas `children`
 */
interface DeviceGuardProps {
  redirectTo?: string;
}

export const DeviceGuard: React.FC<DeviceGuardProps> = ({ 
  redirectTo = '/mobile/dashboard' 
}) => {
  const { isMobile } = useDeviceDetection();

  // Si on est sur mobile, rediriger vers l'app mobile
  if (isMobile) {
    return <Navigate to={redirectTo} replace />;
  }

  // Sinon, rendre les routes enfants (desktop)
  return <Outlet />;
};

